export type ActionRevalidationKind = 0 | 1 | 2

export const ActionDidNotRevalidate = 0
export const ActionDidRevalidateStaticAndDynamic = 1
export const ActionDidRevalidateDynamicOnly = 2
